import React, { useEffect } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button
} from "@mui/material";
import { APIData } from "../../constants/APIAdresses";

const ConfirmDeleteDialog = ({ open, onClose, onDelete, fileItem }) => {
    useEffect(() => {
        console.log("FILEITEM: ",fileItem)
    }, [])
    async function deleteFile() {
        if (fileItem == null) {
            console.error("No file item provided for deletion.");
            return;
        }

        try {
            const response = await fetch(`${APIData.MEDIA}/file/${fileItem.id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                credentials:"include"
            });

            if (!response.ok) {
                throw new Error(`Failed to delete file: ${response.statusText}`);
            }

            onDelete?.(fileItem);
            onClose();
        } catch (error) {
            console.error("Error deleting file:", error);
        }
    }
    return (
        open &&
        <Dialog
            open={open}
            onClose={() => onClose()}
            aria-labelledby="confirm-delete-title"
            aria-describedby="confirm-delete-description"
        >
            <DialogTitle id="confirm-delete-title">Datei löschen?</DialogTitle>

            <DialogContent>
                <DialogContentText id="confirm-delete-description">
                    Möchten Sie die Datei <strong style={{wordBreak:'break-word'}}>{fileItem?.filename}</strong> wirklich löschen?
                    Diese Aktion kann nicht rückgängig gemacht werden.
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => onClose?.()} color="primary">
                    Nein
                </Button>
                <Button onClick={() => deleteFile()} color="error" variant="contained">
                    Ja
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteDialog;
